// @core/api/endpoints/license/deactivate_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeactivateLicenseRequest,
  LicenseResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Deactivate license
 * Deactivates a license on the current platform, releasing the hardware binding so it can be transferred to another machine.
 */
export async function DeactivateLicense(
  license_id: string,
  data: DeactivateLicenseRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/deactivate`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.post<LicenseResponse>(requestPath, data, requestOptions);
}
